import { FETCH_FILTER_INDEX } from '../../actions/jobAction';

const initialState = {

};

export function filterReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {



        case `${FETCH_FILTER_INDEX}_SUCCESS`: {


            return {
                ...state, [payload['data']['type']]: payload['data']['data']
            };

        }






        default:
            return state;
    }
}
